import { useState } from "react";
import { InputIcon } from "primereact/inputicon";
import { EyeIcon, EyeOff } from "lucide-react";

import { InputTextField } from "@/components/organisms/Form";
import { InputTextFieldProps } from "@/components/organisms/Form/Fields/InputTextField/InputTextField";

export const PasswordField = (props: InputTextFieldProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="relative min-h-[76.6px]">
      <InputIcon className="absolute right-3 top-[50%] mt-1" onClick={handleShowPassword}>
        {showPassword ? <EyeIcon size={18} /> : <EyeOff size={18} />}
      </InputIcon>
      <InputTextField
        {...props}
        style={{
          paddingRight: 34,
        }}
        type={showPassword ? "text" : "password"}
      />
    </div>
  );
};
